import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { ModulePageHeader } from '~/components/ModulePageHeader/ModulePageHeader';

export type RiskDetailHeaderProps = {
  name: string;
};

export const RiskDetailHeader = ({ name }: RiskDetailHeaderProps) => {
  const { t } = useTranslation(I18nNamespace.riskSustainability, { keyPrefix: 'RiskDetailHeader' });

  return <ModulePageHeader title={t('title', { name })} />;
};
